import { render, staticRenderFns } from "./DataModelTree.vue?vue&type=template&id=5b43d846&"
import script from "./DataModelTree.vue?vue&type=script&lang=ts&"
export * from "./DataModelTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports